import { BasicEntity, CatalogGridItem } from '../Catalogs'
import { Device } from './Devices'

class LicenseGridItem extends CatalogGridItem {
  userId: number
  user: string
  deviceId: number
  device: string
  uuid: string
  active: string
  acquiredDate: string
  releaseDate: string
  _selected: boolean
}

class License {
  id: number
  user: BasicEntity
  device: Device
  active: boolean
  acquiredDate: Date
  releaseDate: Date | undefined

  static getInstanceForEdit () {
    const license = new License()
    license.user = new BasicEntity(-1, '')
    license.device = Device.getInstanceForEdit()
    license.active = false
    license.acquiredDate = new Date()
    return license
  }
}

class LicenseCatalogFilters {
  userId: number
  deviceId: number
  active: boolean
  domain: number
}

export { License }
export { LicenseGridItem, LicenseCatalogFilters as LicenseFilters }
